module.exports = __webpack_public_path__ + "img/AM.6ab4c4d0.svg";